import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card/card.component';

@NgModule({
    declarations: [
        
    ],
    imports     : [
        CommonModule,FuseCardComponent
    ],
    exports     : [
        FuseCardComponent
    ]
})
export class FuseCardModule
{
}
